import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Popover} from "react-bootstrap";
import './SupplierRatePopover.css'

class SupplierRatePopover extends Component {
    static propTypes = {
        rate: PropTypes.number,
        onSave: PropTypes.func,
        close: PropTypes.func.isRequired
    };
    static defaultProps = {};
    state = {
        rate: this.props.rate || ''
    };

    render() {
        const {rate, close, onSave, ...props} = this.props;
        return (
            <Popover id="supplier-rate-popover" {...props}>
                <div className="m-b-2">
                    <div className="input-group">
                        <input type="number" className="form-control"
                               min="0"
                               value={this.state.rate}
                               onChange={event => this.setState({rate: parseInt(event.target.value)})}/>
                        <span className="input-group-addon">р.</span>
                    </div>
                </div>
                <div className="clearfix">
                    <button type="button" className="btn btn-default btn-3d"
                            onClick={() => close()}>
                        Отмена
                    </button>
                    <button type="button" className="btn btn-success btn-3d pull-right"
                            onClick={() => this.saveRate()}>
                        Сохранить
                    </button>
                </div>
            </Popover>
        );
    }

    saveRate() {
        const {onSave, close} = this.props;

        if (onSave) onSave(this.state.rate);
        close();
    }
}

export default SupplierRatePopover;


// WEBPACK FOOTER //
// ./src/pages/TenderBlock/TenderRequests/popovers/SupplierRatePopover.js